"use strict"

// serializace formu na ruční pohon; příme vytvoření new FormData(form) má několik potíží, které nelze jednoduše řešit, vyrábí prázdné soubory a tak... //

export class Form {
    
    static serialize(form, ajax) {
	
		let checkboxes={};

        let i, j;
        for (i = form.elements.length - 1; i >= 0; i--) {
            if (form.elements[i].name === "") {
                continue;
            }

            switch (form.elements[i].nodeName) {
                case 'INPUT':
                    switch (form.elements[i].type) {
                        case 'hidden':
							if (typeof checkboxes[form.elements[i].name] == 'undefined')
								ajax.addData(form.elements[i].name, form.elements[i].value);
						
						break;
                        case 'checkbox':
                            if (form.elements[i].checked) { 
								ajax.addData(form.elements[i].name, form.elements[i].value);
								checkboxes[form.elements[i].name]=true;
							}
							break;
						
                        case 'radio':
                            if (form.elements[i].checked) { 
                                    ajax.addData(form.elements[i].name, form.elements[i].value);
                            }
                            break;
                        case 'file':
                            let files = form.elements[i].files;
                            for (j = 0; j < files.length; j++) {
                                var file = files [j];
                                ajax.addData(form.elements[i].name, file);
                            }
                            break;
                        case 'button':
                        case 'reset':
                        case 'submit':
                            // buttony jako takove neodesilame, pokud na ne nebylo kliknuto a to se resi jinde
                            continue;
                            break;
                        default:
                            ajax.addData(form.elements[i].name, form.elements[i].value);                        
                    }
                    break;

                case 'TEXTAREA':
                    ajax.addData(form.elements[i].name, form.elements[i].value);
                    break;
                case 'SELECT':
                    switch (form.elements[i].type) {
                        case 'select-one':
                            ajax.addData(form.elements[i].name, form.elements[i].value);
                            break;
                        case 'select-multiple':
                            for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                                if (form.elements[i].options[j].selected) {
                                    ajax.addData(form.elements[i].name, form.elements[i].options[j].value);
                                }
                            }
                            break;
                    }
                    break;
                case 'BUTTON':
                    break;
            }

        }

        // return ret;
    }
    
    
}